export default __webpack_public_path__ + "static/media/mission.4779ce49.png";